<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!items.length"
  >
    <vbt-table
      :headers="headers"
      :items="items"
      show-paginator
    >
      <template #file="{ item }">
        <v-tooltip
          v-if="item.fileUrl"
          top
        >
          <template #activator="{ on }">
              <span v-on="on">
                <a
                  :href="item.fileUrl"
                  target="_blank"
                >
                  File URL
                </a>
              </span>
          </template>
          Hash: {{ item.fileHash }}
        </v-tooltip>
      </template>
      <template #foil="{ item }">
        <v-layout column>
          <v-tooltip
            v-if="item.foilFileUrl"
            top
          >
            <template #activator="{ on }">
              <span v-on="on">
                <a
                  :href="item.foilFileUrl"
                  target="_blank"
                >
                  File URL
                </a>
              </span>
            </template>
            Hash: {{ item.foilFileHash }}
          </v-tooltip>
          <v-layout v-if="item.foilColor">
            Color: {{ item.foilColor }}
          </v-layout>
        </v-layout>
      </template>
      <template #spotUv="{ item }">
        <v-tooltip
          v-if="item.spotUvFileUrl"
          top
        >
          <template #activator="{ on }">
              <span v-on="on">
                <a
                  :href="item.spotUvFileUrl"
                  target="_blank"
                >
                  File URL
                </a>
              </span>
          </template>
          Hash: {{ item.spotUvFileHash }}
        </v-tooltip>
      </template>
      <template #variableUv="{ item }">
        <v-tooltip
          v-if="item.variableUvFileUrl"
          top
        >
          <template #activator="{ on }">
              <span v-on="on">
                <a
                  :href="item.variableUvFileUrl"
                  target="_blank"
                >
                  File URL
                </a>
              </span>
          </template>
          Hash: {{ item.variableUvFileHash }}
        </v-tooltip>
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
const headers = Object.freeze([
  { text: 'Order Item ID', value: 'outerId' },
  { text: 'Laminating', value: 'laminating' },
  { text: 'Print Asset', value: 'printAsset' },
  { text: 'File', value: 'file' },
  { text: 'Foil', value: 'foil' },
  { text: 'SpotUV', value: 'spotUv' },
  { text: 'VariableUV', value: 'variableUv' },
]);

export default {
  name: 'KernelOrderFilesList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
};
</script>
